// From backend/src/utils/errors/firebaseCustomError.ts
export enum FirebaseErrorCodeEnum {
  UNAUTHORIZED = 'UNAUTHORIZED',
  UNAUTHENTICATED = 'UNAUTHENTICATED',
  SESSION_EXPIRED = 'SESSION_EXPIRED',
  SESSION_REVOKED = 'SESSION_REVOKED',
  RECENT_SIGN_IN_REQUIRED = 'RECENT_SIGN_IN_REQUIRED',
  PHONE_NOT_VERIFIED = 'PHONE_NOT_VERIFIED',
  SECOND_FACTOR_REQUIRED = 'SECOND_FACTOR_REQUIRED',
  PHONE_ALREADY_VERIFIED = 'PHONE_ALREADY_VERIFIED',
  AWAITING_VALIDATION = 'AWAITING_VALIDATION',
}
